import React, { Component } from 'react';
import { transferHundredPoint } from '../../utils/Shared/methods';
import './index.scss';
import arrowUp from '../../../images/arrowUp.png'
import arrowDown from '../../../images/arrowDown.png'

class EvacuationChartTable extends Component {
	constructor(params) {
		super(params);
		this.state = {
			csvData: [],
			ascendingSort: {
				0:{
					0: true,
					1: true,
					2: true,
					3: true,
				},
				1:{
					0: true,
					1: true,
					2: true,
					3: true,
				},
				2:{
					0: true,
					1: true,
					2: true,
					3: true,
				},
				3:{
					0: true,
					1: true,
					2: true,
					3: true,
				},
				4:{
					0: true,
					1: true,
					2: true,
					3: true,
				},
				5:{
					0: true,
					1: true,
					2: true,
					3: true,
				},
				6:{
					0: true,
					1: true,
					2: true,
					3: true,
				},
				7:{
					0: true,
					1: true,
					2: true,
					3: true,
				},
				8:{
					0: true,
					1: true,
					2: true,
					3: true,
				},
				9:{
					0: true,
					1: true,
					2: true,
					3: true,
				},
			}
		};
	}
	componentDidUpdate(prevProps, prevState) {
		if (prevProps !== this.props) {
			this.handleLoadCsvData();
		}
	}
	componentDidMount() {
		this.handleLoadCsvData();
	}
	handleLoadCsvData() {
		if (this.props.csvData) {
			const { csvData } = this.props
			csvData.forEach((data) => {
				if (data) {
					data.table = data.csv.split('\r\n').map((row) => {
						return row.split(',');
					})
					data.table = data.table.filter(row => row.length > 1)
				}
			})
			this.setState({ csvData })
		}
		else {
			this.setState({
				csvData: [],
			})
		}
	}

	sortCsvData = (indicator, column) =>{
		const { csvData, ascendingSort } = this.state
		ascendingSort[indicator][column] = !ascendingSort[indicator][column]

		if(csvData[indicator] && csvData[indicator].table.length > 1){
			const header = csvData[indicator].table[0]
			const dataRows = csvData[indicator].table.slice(1)

			if(ascendingSort[indicator][column]){//升冪
				if(column === 0){
					dataRows.sort((a,b) =>{
						if(a[column] && b[column]){
							return a[column].localeCompare(b[column], "zh-Hant")
						}
						return 0
					})
				}else{
					dataRows.sort((a, b) =>{
						if(isNaN(a[column]) || isNaN(b[column])){
							return a[column].localeCompare(b[column], "zh-Hant")
						}
						return Number(a[column])-Number(b[column])
					})
				}
			}else{//降冪
				if(column === 0){
					dataRows.sort((a,b) =>{
						if(a[column] && b[column]){
							return -a[column].localeCompare(b[column], "zh-Hant")
						}
						return 0
					})
				}else{
					dataRows.sort((a, b) =>{
						if(isNaN(a[column]) || isNaN(b[column])){
							return -a[column].localeCompare(b[column], "zh-Hant")
						}
						return Number(b[column])-Number(a[column])
					})
				}
			}

			csvData[indicator].table = [header, ...dataRows]
		}

		this.setState({csvData, ascendingSort});
	}

	render() {
		const { csvData, ascendingSort } = this.state
		const { currentTopic, subjectTitle } = this.props
		return (
			<React.Fragment>
				{
					csvData &&
					csvData.map((indicator, indicatorIndex) => {
						return (
							indicator &&
							<React.Fragment key={indicatorIndex}>
								<p className="evacuation-datatitle">{ indicator.title }</p>
								<table className={`evacuation-datatable evacuation-data-table${currentTopic === 'event' ? ' -event-topic' : ''}${subjectTitle === 'alert' ? ' -alert-page' : ''}`}>
									<tbody>
										{
											indicator &&
											indicator.table.map((tableRow, tableRowIndex) => {
												if(tableRowIndex === 0){
													return <React.Fragment key={tableRowIndex}>
																<tr style={{position:'sticky', top:0, zIndex:1, borderTop:0, backgroundColor:'#fff'}}>{
																	tableRow.length > 1 &&
																	tableRow.map((tableData, tableDataIndex) => {
																		// 檢查該欄位的第一筆數據是否為數值
																		const firstDataRow = indicator.table[1];
																		const isNumericColumn = firstDataRow && isFinite(firstDataRow[tableDataIndex]) && firstDataRow[tableDataIndex] !== '' && tableDataIndex !== 0;

																		return (
																			<td className={isNumericColumn ? 'evacuation-datatable-td-right' : ''} style={{cursor:"pointer"}} onClick={()=>this.sortCsvData(indicatorIndex ,tableDataIndex)}>
																				{ tableData }
																				{
																					!ascendingSort[indicatorIndex][tableDataIndex] &&
																					<img className="arrow" src={arrowDown} alt=""/>
																				}
																				{
																					ascendingSort[indicatorIndex][tableDataIndex] &&
																					<img className="arrow" src={arrowUp} alt=""/>
																				}
																			</td>
																		)
																	})
																}</tr>
															</React.Fragment>
												}
												return (
													<React.Fragment key={tableRowIndex}>
														<tr>{
															tableRow.length > 1 &&
															tableRow.map((tableData, tableDataIndex) => {
																return (
																	<React.Fragment key={tableDataIndex}>
																		{
																			((!isFinite(tableData) || tableData==='') || tableDataIndex === 0 || tableRowIndex === 0)
																			?<td>{ tableData }</td>
																			:<td className='evacuation-datatable-td-right'>{ transferHundredPoint(tableData) }</td>
																		}
																	</React.Fragment>
																)
															})
														}</tr>
													</React.Fragment>
												)
											})
										}
									</tbody>
								</table>
							</React.Fragment>
						)
					})
				}
			</React.Fragment>
		);
	}
}

export default EvacuationChartTable;
